'use client';
import React from 'react';
import { Send } from 'lucide-react';
import { trackEvent } from '@/components/common/Analytics';

const ContactForm = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic here
  };

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2 px-3 py-1 bg-green-50 text-green-700 rounded-full w-fit border border-green-100">
          <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></div>
          <span className="text-xs font-bold uppercase tracking-wider">Fast Response: &lt; 2 Hours</span>
        </div>
        <p className="text-[16px] text-[#475467]">
          Have a label requirement or a quick technical question?<br />
          Fill out the form and our technical experts will get back to you with a tailored consultation.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-6 w-full">
        <div className="w-full mb-5">
          <label htmlFor="firstName" className="block text-[14px] font-medium text-[#1D2939] mb-2">First name</label>
          <input
            type="text"
            id="firstName"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#112140] focus:border-[#112140]"
            placeholder="First name"
          />
        </div>

        <div className="w-full mb-5">
          <label htmlFor="companyName" className="block text-[14px] font-medium text-[#1D2939] mb-2">Company Name</label>
          <input
            type="text"
            id="companyName"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#112140] focus:border-[#112140]"
            placeholder="Company name"
          />
        </div>

        <div className="w-full mb-5">
          <label htmlFor="email" className="block text-[14px] font-medium text-[#1D2939] mb-2">Email Address</label>
          <input
            type="email"
            id="email"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#112140] focus:border-[#112140]"
            placeholder="your@email.com"
          />
        </div>

        <div className="w-full mb-5 relative">
          <label htmlFor="phone" className="block text-[14px] font-medium text-[#1D2939] mb-2">Phone number</label>
          <div className="flex">
            <select className="border border-[#D0D5DD] border-r-0 rounded-l-xl px-2 bg-white text-[14px] text-[#1D2939] focus:outline-none focus:ring-2 focus:ring-[#112140] appearance-none cursor-pointer">
              <option value="+91">🇮🇳 IN</option>
              <option value="+1">🇺🇸 US</option>
              <option value="+44">🇬🇧 UK</option>
              <option value="+971">🇦🇪 UAE</option>
              <option value="+61">🇦🇺 AU</option>
              <option value="+1">🇨🇦 CA</option>
              <option value="+49">🇩🇪 DE</option>
              <option value="+33">🇫🇷 FR</option>
              <option value="+65">🇸🇬 SG</option>
              <option value="+81">🇯🇵 JP</option>
              <option value="+86">🇨🇳 CN</option>
              <option value="+7">🇷🇺 RU</option>
              <option value="+55">🇧🇷 BR</option>
              <option value="+27">🇿🇦 ZA</option>
              <option value="+966">🇸🇦 SA</option>
            </select>
            <input
              type="tel"
              id="phone"
              className="w-full px-4 py-3 border border-[#D0D5DD] rounded-r-xl focus:outline-none focus:ring-2 focus:ring-[#112140] focus:border-[#112140]"
              placeholder="000 000 0000"
            />
          </div>
        </div>

        <div className="w-full mb-5">
          <label htmlFor="message" className="block text-[14px] font-medium text-[#1D2939] mb-2">Message</label>
          <textarea
            id="message"
            rows={4}
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#112140] focus:border-[#112140]"
            placeholder="Not sure what you want? Just describe your use case, and we'll guide you."
          ></textarea>
        </div>

        <button
          type="submit"
          onClick={() => trackEvent('form_submission_start', 'Contact', 'Submit Inquiry')}
          className="mt-2 w-full bg-[#112140] hover:bg-blue-700 text-white font-bold py-4 px-4 rounded-full transition-all duration-300 flex items-center justify-center gap-3 shadow-lg shadow-blue-900/10 hover:-translate-y-0.5 active:translate-y-0"
        >
          <span>Submit Technical Inquiry</span>
          <Send className="w-4 h-4" />
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
